<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="state" label="流转状态">
        <el-select v-model="searchModel.state" placeholder="请选择" @change="getTableData(true)">
          <el-option label="审核中" value="7"></el-option>
          <el-option label="批准中" value="8"></el-option>
          <el-option label="批准通过" value="9"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="reportCode" label="委托编号">
        <el-input
          v-model="searchModel.reportCode"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="client" label="委托单位">
        <el-input
          v-model.trim="searchModel.client"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="sampleName" label="样品名称">
        <el-input
          v-model="searchModel.sampleName"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="itemName" label="检测项目">
        <el-input
          v-model="searchModel.itemName"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="orderType" label="排序规则">
        <el-select v-model="searchModel.orderType" placeholder="请选择" clearable @change="getTableData(true)">
          <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="text" class="search-isOpen" @click="collapsed = !collapsed">
          {{ collapsed ? '展开' : '收起' }}
          <i class="el-icon--right" :class="collapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" :hasColumnsSettinng="false" @onRefresh="getTableData()"></TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="委托单编号" width="160" align="center" fixed>
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleProcess(row)">{{ row.reportCode }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="client" label="委托单位" min-width="150" align="center"></el-table-column>
        <el-table-column prop="sampleName" label="样品名称" min-width="150" align="center"></el-table-column>
        <el-table-column label="检测项目" align="center">
          <template v-slot="{ row }">
            <div v-for="(testItem, index) in row.testItemList" :key="index">{{ testItem }}</div>
          </template>
        </el-table-column>
        <el-table-column label="检测依据" align="center">
          <template v-slot="{ row }">
            <div v-for="(basis, index) in row.basisList" :key="index">{{ basis.basisName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="syrName" label="检测人员" align="center"></el-table-column>
        <el-table-column prop="testDate" label="完成试验时间" width="100" align="center"></el-table-column>

        <el-table-column label="操作" width="280" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="saveOriData(row.entrustmentId)">保存原始记录</el-link>
            <!-- <el-link type="primary" @click="saveOriDataByFM(row.entrustmentId)">原始记录ByFM</el-link> 
            <br />-->
            <el-link type="primary" @click="saveReport(row.entrustmentId, 0)">保存报告</el-link>
            <el-link v-if="row.unqlfCnt && row.unqlfCnt > 0" type="primary" @click="saveReport(row.entrustmentId, 1)">
              保存报告(不合格)
            </el-link>
            <!-- <br />
           <el-link type="primary" @click="saveReportByFM(row.entrustmentId, 0)">报告ByFM</el-link> 
            <el-link v-if="row.unqlfCnt && row.unqlfCnt > 0" type="primary" @click="saveReportByFM(row.entrustmentId, 1)">
              报告(不合格)ByFM
            </el-link> -->
            <br />
            <el-link type="primary" @click="sealRowReport(row.entrustmentId, 0)">盖章</el-link>
            <el-link type="primary" @click="sealRowReport(row.entrustmentId, 1)">盖章(不合格)</el-link>
            <br />
            <el-link type="primary" @click="buildPDF(row.entrustmentId, 0)">生成pdf</el-link>
            <el-link type="primary" @click="buildPDF(row.entrustmentId, 1)">生成pdf(不合格)</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 流程信息 -->
    <ProcessDialog :visible.sync="processVisible" :activeId="activeRowId" />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';

import TableHeader from '@/components/TableHeader';
import ProcessDialog from '@/components/BusinessComponents/ProcessDialog';
import AuditDialog from '@/components/BusinessComponents/AuditDialog';
import EntrustTable from '@/components/BusinessComponents/EntrustTable';

import { getFlowList } from '@/api/flow';
import { getEntrustment } from '@/api/entrust';

export default {
  components: { TableHeader, ProcessDialog, AuditDialog, EntrustTable },
  data() {
    return {
      collapsed: true,
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        reportCode: '',
        client: '',
        sampleName: '',
        itemName: null,
        orderType: 2,
        state: '7',
        dateRange: []
      },
      orderTypeOptions: [
        {
          value: 2,
          label: '编号降序'
        },
        {
          value: 3,
          label: '编号升序'
        },
        {
          value: 0,
          label: '创建时间降序'
        },
        {
          value: 1,
          label: '创建时间升序'
        }
      ],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      activeRowId: null,
      activeRowInfo: {},
      processVisible: false,
      auditTitle: '报告批准',
      auditVisible: false,
      hasUnqlf: false, // 是否有不合格样品
      auditEntrustData: {},
      pdfTimes: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    handleDeliverState() {
      this.getTableData(true);
      this.$nextTick(() => {
        this.$refs.table.doLayout(); // 重置表格布局
      });
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getFlowList({ ...this.searchModel, startTime, endTime });

      this.dataTotal = data.count;
      const tableData = data.list || [];
      this.tableData = tableData.map(item => {
        const basis = JSON.parse(item.basisJson);
        const testItem = basis.map(item => item.itemName);
        // 去重
        const uniqueTestItem = [...new Set(testItem)];

        item.testItemList = uniqueTestItem;
        item.basisList = basis || [];

        return item;
      });

      this.tableLoading = false;
    },
    handleProcess(row) {
      this.activeRowId = row.entrustmentId;
      this.processVisible = true;
    },
    handleAudit(row) {
      this.auditTitle = `报告批准【${row.reportCode}】`;
      this.activeRowId = row.entrustmentId;
      this.hasUnqlf = row?.unqlfCnt > 0 ? true : false;
      this.getEntrustData(row.entrustmentId);
      this.auditVisible = true;
    },
    async getEntrustData(id) {
      const { data } = await getEntrustment({ id });
      this.auditEntrustData = data;
    },
    saveOriData(entrustmentId) {
      const params = JSON.stringify({
        token: getToken(),
        wordType: 'oriData',
        entrustmentId,
        hasCallback: 1
      });
      // eslint-disable-next-line no-undef
      POBrowser.openWindow('pageOffice/oriData', 'width=1200px;height=800px;', params);
    },
    saveOriDataByFM(entrustmentId) {
      const token = getToken();

      filemakerctrl.CallFileMaker({
        // url：指向服务器端FileMakerCtrl打开文件的controller地址，该地址需从"/"开始，指向服务器端根目录
        url: `/app/office/reqOriWordFillV1ByFM?token=${token}&entrustmentId=${entrustmentId}&readonly=0`,
        success: res => {
          //res：获取服务器端fs.setCustomSaveResult设置的保存结果
          console.log('completed successfully.');
        },
        progress: pos => {
          console.log('running ' + pos + '%', new Date());
        },
        error: msg => {
          console.log('msg 打印:', msg);
        }
      });
    },
    saveReport(entrustmentId, ft) {
      const params = JSON.stringify({
        token: getToken(),
        wordType: 'report',
        entrustmentId,
        ft,
        hasCallback: 1
      });
      if (ft == 0) {
        // eslint-disable-next-line no-undef
        POBrowser.openWindow('pageOffice/report', 'width=1200px;height=800px;', params);
      } else {
        // eslint-disable-next-line no-undef
        POBrowser.openWindow('pageOffice/reportFail', 'width=1200px;height=800px;', params);
      }
    },
    saveReportByFM(entrustmentId, ft) {
      const token = getToken();

      filemakerctrl.CallFileMaker({
        // url：指向服务器端FileMakerCtrl打开文件的controller地址，该地址需从"/"开始，指向服务器端根目录
        url: `/app/office/reqReportWordFillByFM?token=${token}&entrustmentId=${entrustmentId}&ft=${ft}&readonly=0`,
        success: res => {
          //res：获取服务器端fs.setCustomSaveResult设置的保存结果
          console.log('completed successfully.');
        },
        progress: pos => {
          console.log('running ' + pos + '%', new Date());
        },
        error: msg => {
          console.log('msg 打印:', msg);
        }
      });
    },
    sealRowReport(entrustmentId, ft) {
      const params = JSON.stringify({
        token: getToken(),
        wordType: 'sealReport',
        entrustmentId,
        ft
      });
      if (ft == 0) {
        // eslint-disable-next-line no-undef
        POBrowser.openWindow('pageOffice/report', 'width=1200px;height=800px;', params);
      } else {
        // eslint-disable-next-line no-undef
        POBrowser.openWindow('pageOffice/report', 'width=1200px;height=800px;', params);
      }
    },
    buildPDF(entrustmentId, ft) {
      const token = getToken();

      filemakerctrl.CallFileMaker({
        // url：指向服务器端FileMakerCtrl打开文件的controller地址，该地址需从"/"开始，指向服务器端根目录
        url: `/app/office/reqReportPdf?token=${token}&ft=${ft}&entrustmentId=${entrustmentId}&t=${this.pdfTimes}`,
        success: res => {
          //res：获取服务器端fs.setCustomSaveResult设置的保存结果
          console.log('completed successfully.');
        },
        progress: pos => {},
        error: msg => {
          console.log('msg 打印:', msg);
          this.pdfTimes += 1;
        }
      });
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.audit-container {
  height: 100%;

  .table-wrap {
    height: calc(100% - 42px);
    margin-top: 10px;
    overflow: hidden;
    overflow-y: auto;
  }
}
</style>
